import React from "react";

function AddLeagueModal({ fetchLeagues }) {
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);

        try {
            // Retrieve the CSRF token from cookies
            const response = await fetch("/api/leagues/add/", {
                method: "POST",
                withCredentials: true,
                body: formData,
            });

            if (response.ok) {
                e.target.reset();
                fetchLeagues();
                document.querySelector("#addLeagueModal .btn-close").click(); // Close modal
            } else {
                const errorData = await response.json();
                alert(`Error: ${JSON.stringify(errorData.errors || errorData)}`);
            }
        } catch (error) {
            console.error("Error creating league:", error);
            alert("An error occurred. Please try again.");
        }
    };

    return (
        <div
            className="modal fade"
            id="addLeagueModal"
            tabIndex="-1"
            aria-labelledby="addLeagueModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="addLeagueModalLabel">
                            Add New League
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="leagueName" className="form-label">
                                    League Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="leagueName"
                                    name="name"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="leagueDescription" className="form-label">
                                    Description
                                </label>
                                <textarea
                                    className="form-control"
                                    id="leagueDescription"
                                    name="description"
                                    rows="3"
                                ></textarea>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="leagueLocation" className="form-label">
                                    Location
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="leagueLocation"
                                    name="location"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="leagueLogo" className="form-label">
                                    Logo
                                </label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="leagueLogo"
                                    name="logo"
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="leagueBanner" className="form-label">
                                    Banner
                                </label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="leagueBanner"
                                    name="banner"
                                />
                            </div>
                            <button type="submit" className="btn btn-primary">
                                Create League
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddLeagueModal;
